/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Mask_NoneInputs */

const en_landing_studio_mask_none = /** @type {(inputs: Landing_Studio_Mask_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No mask: the whole image may change. Paint an area for a precise edit.`)
};

const zh_landing_studio_mask_none = /** @type {(inputs: Landing_Studio_Mask_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未涂抹：整张图都可能变化。涂出区域即可精准编辑。`)
};

/**
* | output |
* | --- |
* | "No mask: the whole image may change. Paint an area for a precise edit." |
*
* @param {Landing_Studio_Mask_NoneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_mask_none = /** @type {((inputs?: Landing_Studio_Mask_NoneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Mask_NoneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_mask_none(inputs)
	return zh_landing_studio_mask_none(inputs)
});
export { landing_studio_mask_none as "landing.studio.mask_none" }